import { Injectable } from '@angular/core';
import { ICandidatureFrontend } from '@model/agoranos/candidature-frontend.model';
import { ICandidature } from '@model/ferias/candidature.model';
import { ICandidatureFrontendFlorestas } from '@model/florestas/candidature-frontend.model';
import { ICandidatureFrontendGeracaoz } from '@model/geracaoz/candidature-frontend.model';
import { ICandidatureFrontendNamorar } from '@model/namorar/candidature-frontend.model';
import { ICandidatureFrontendNavegas } from '@model/navegas/candidature-frontend.model';
import { IShortCandidature } from '@model/otl/short-candidature.model';
import { ICandidatureFrontendSetentaja } from '@model/setentaja/candidature-frontend.model';
import { ICandidatureFrontendSoudigital } from '@model/soudigital/candidature-frontend.model';

@Injectable({ providedIn: 'root' })
export class SharedDataService {
  constructor() {}

  private _candidatureId?: number;

  get candidatureId(): number | undefined {
    return this._candidatureId;
  }

  set candidatureId(value: number | undefined) {
    this._candidatureId = value;
  }

  private _agoraNosCandidature?: ICandidatureFrontend;

  get agoraNosCandidature(): ICandidatureFrontend | undefined {
    return this._agoraNosCandidature;
  }

  set agoraNosCandidature(value: ICandidatureFrontend | undefined) {
    this._agoraNosCandidature = value;
  }

  private _florestasCandidature?: ICandidatureFrontendFlorestas;

  get florestasCandidature(): ICandidatureFrontendFlorestas | undefined {
    return this._florestasCandidature;
  }

  set florestasCandidature(value: ICandidatureFrontendFlorestas | undefined) {
    this._florestasCandidature = value;
  }

  private _feriasCandidature?: ICandidature;

  get feriasCandidature(): ICandidature | undefined {
    return this._feriasCandidature;
  }

  set feriasCandidature(value: ICandidature | undefined) {
    this._feriasCandidature = value;
  }

  private _otlCandidature?: IShortCandidature;

  get otlCandidature(): IShortCandidature | undefined {
    return this._otlCandidature;
  }

  set otlCandidature(value: IShortCandidature | undefined) {
    this._otlCandidature = value;
  }

  private _setentajaCandidature?: ICandidatureFrontendSetentaja;

  get setentajaCandidature(): ICandidatureFrontendSetentaja | undefined {
    return this._setentajaCandidature;
  }

  set setentajaCandidature(value: ICandidatureFrontendSetentaja | undefined) {
    this._setentajaCandidature = value;
  }

  private _soudigitalCandidature?: ICandidatureFrontendSoudigital;

  get soudigitalCandidature(): ICandidatureFrontendSoudigital | undefined {
    return this._soudigitalCandidature;
  }

  set soudigitalCandidature(value: ICandidatureFrontendSoudigital | undefined) {
    this._soudigitalCandidature = value;
  }

  private _navegasCandidature?: ICandidatureFrontendNavegas;

  get navegasCandidature(): ICandidatureFrontendNavegas | undefined {
    return this._navegasCandidature;
  }

  set navegasCandidature(value: ICandidatureFrontendNavegas | undefined) {
    this._navegasCandidature = value;
  }

  private _namorarCandidature?: ICandidatureFrontendNamorar;

  get namorarCandidature(): ICandidatureFrontendNamorar | undefined {
    return this._namorarCandidature;
  }

  set namorarCandidature(value: ICandidatureFrontendNamorar | undefined) {
    this._namorarCandidature = value;
  }

  private _geracaozCandidature?: ICandidatureFrontendGeracaoz;

  get geracaozCandidature(): ICandidatureFrontendGeracaoz | undefined {
    return this._geracaozCandidature;
  }

  set geracaozCandidature(value: ICandidatureFrontendGeracaoz | undefined) {
    this._geracaozCandidature = value;
  }
}
